export default "__VITE_ASSET__BTdUrJ10__"